export default __webpack_public_path__ + "static/media/Aelfrith's Gratitude.a929b900.jpg";